import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const authGuard = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const redirectURL = state.url === '/dashboard' ? '/' : state.url;

  return authService.check().pipe(
    switchMap(isAuthenticated => {
      if (!isAuthenticated) {
        return router.navigate(['login'], { queryParams: { redirectURL } }).then(() => {
          return of(false);
        });
      }
      return of(true);
    })
  );
};
